<template>
    <ButtonWithAdminTooltip :disabled="!isTenantAdmin" :tooltipText="t('shared.ask_admin_to_upgrade')">
        <Button severity="primary" outlined :size="size" :label="label ?? t('billing.upgradePlan')"
            icon="pi pi-arrow-circle-up" :disabled="!isTenantAdmin" class="whitespace-nowrap shrink-0"
            @click="openDialog" />
    </ButtonWithAdminTooltip>
    <PlanSwitchDialog v-model:visible="visible" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import Button from 'primevue/button'
import { useI18n } from 'vue-i18n'
import { useFeaturesStore } from '@/stores/features'
import ButtonWithAdminTooltip from '@/components/shared/ButtonWithAdminTooltip.vue'
import PlanSwitchDialog from '@/components/settings/billing/PlanSwitchDialog.vue'
import { useSelfServeGate } from '@/composables/useSelfServeGate'

withDefaults(defineProps<{
    size?: 'small' | 'large' | undefined
    label?: string
}>(), {
    size: 'small',
    label: undefined,
})

const { t } = useI18n()
const featuresStore = useFeaturesStore()
const { shouldContactSalesForPlanSwitch, openContactSales } = useSelfServeGate()
const isTenantAdmin = computed(() => featuresStore.isTenantAdmin)

const visible = ref(false)

// Only admins can switch the plan; non-admins get the "ask your admin" tooltip
// (the button stays disabled and the dialog never opens for them).
function openDialog() {
    if (!isTenantAdmin.value) return
    // Existing tenants never self-serve a plan change while gated (MYAC-837) —
    // redirect to Contact sales before the price picker can open.
    if (shouldContactSalesForPlanSwitch()) {
        openContactSales('upgrade')
        return
    }
    visible.value = true
}
</script>

<style scoped></style>
